import {AnyAction} from 'redux';
import {ThunkAction, ThunkDispatch} from 'redux-thunk';
import {AppState} from '../../../store';
import {xhrHelper} from '../../../utils/xhrHelper';
import axios from 'axios';

import {
  updateMoreImages,
  updateHasMoreImages,
  updateReviewDataStatus,
  updateHasDataAction,
  setSnapDataAction,
  updateHasUserReview,
  updateUserReview,
  setQNAFilters,
  updateQnaDataStatus,
  updateHasQnaDataAction,
  setQNAData,
} from './actions';

import {QNADataType, QuesDetailType, GIDataType, ReviewDataList, SnapDataType} from './types';

// for traveller images in image gallery popup
var ajaxCallLocked = false;
export const fetchMoreImages = (
  hotelId,
  offset,
  limit,
): ThunkAction<void, AppState, {}, AnyAction> => {
  // Invoke API
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    // getState()
    let url =
      'https://ugcx.goibibo.com/api/Images/getApprovedImages/?vid=' +
      hotelId +
      '&offset=' +
      offset +
      '&limit=' +
      limit;
    if (ajaxCallLocked) {
      return;
    }

    ajaxCallLocked = true;

    xhrHelper({
      name: 'UGC Images API',
      type: 'GET',
      url: url,
    })
      .then(response => {
        if (response && response.data) {
          let data = response.data as Array<any>;
          dispatch(updateHasMoreImages(true));
          dispatch(updateMoreImages(data));
          if (data.length > 0) {
            ajaxCallLocked = false;
          }
        }
      })
      .catch(() => {
        dispatch(updateHasMoreImages(false));
        ajaxCallLocked = false;
      });
  };
};

//fetch rating overview data of RNR
export const fetchSnapData = (hotelId): ThunkAction<void, AppState, {}, AnyAction> => {
  let url = 'https://ugcx.goibibo.com/api/Hotels/snapshot?vid=' + hotelId + '&type=ta';

  // Invoke API
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    dispatch(updateReviewDataStatus(true));
    xhrHelper({
      name: 'Snapshot Data API',
      type: 'GET',
      url: url,
    })
      .then(response => {
        if (response && response.data) {
          let data = response.data as SnapDataType;
          dispatch(updateHasDataAction(true));
          dispatch(updateReviewDataStatus(false));
          dispatch(setSnapDataAction(data));
        }
      })
      .catch(() => {
        dispatch(updateHasDataAction(false));
      });
  };
};

//to fetch user reviews in RNR
export const fetchUserReviews = (
  hotelId,
  offset,
  limit,
  tagIds = [],
  filter,
  sortBy,
): ThunkAction<void, AppState, {}, AnyAction> => {
  // Invoke API
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    // getState()
    let url =
      'https://ugcx.goibibo.com/api/HotelReviews/forMobileV4/' +
      hotelId +
      '?offset=' +
      offset +
      '&limit=' +
      limit;
    if (tagIds.length > 0) {
      url += '&tagIds=' + JSON.stringify(tagIds);
    }
    if (filter) {
      url += '&filter=' + filter;
    }
    url += '&sortBy=' + sortBy + '&webp=true' + '&flavour=dWeb';

    xhrHelper({
      name: 'User Review API',
      type: 'GET',
      url: url,
    })
      .then(response => {
        let data = {};
        if (response && response.data) {
          data = response.data as ReviewDataList;
          dispatch(updateUserReview(data));
          if (response.data.reviews.length > 0) {
            dispatch(updateHasUserReview(true));
          }
        }
      })
      .catch(() => {
        dispatch(updateHasUserReview(false));
      });
  };
};

// For Qna filter list
export const getQnaFilters = (id, type): ThunkAction<void, AppState, {}, AnyAction> => {
  // Invoke API
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    // getState()
    const url = 'https://ugc.goibibo.com/api/Questions/getQuestionFilter';
    const options = {
      params: {
        id: id,
        type: type,
      },
    };

    axios
      .get(url, options)
      .then(response => {
        let data = [];
        if (response && response.data) {
          data = response.data;
          dispatch(setQNAFilters(data));
        }
      })
      .catch(err => {
        console.log('Filter Qna API call failed');
        console.trace(err);
        dispatch(setQNAFilters([]));
      });
  };
};

//Fetch Qna data
export const fetchQnA = (
  hotelId,
  offset,
  limit,
  sortBy,
  filter,
): ThunkAction<void, AppState, {}, AnyAction> => {
  // Invoke API
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    // getState()
    let url =
      'https://ugc.goibibo.com/api/Questions/getHotelQuestionsWeb/?offset=' +
      offset +
      '&limit=' +
      limit +
      '&vid=' +
      hotelId;
    url += '&sortBy=' + sortBy;
    if (filter.length > 0) {
      url += '&filters=[' + filter + ']';
    }

    xhrHelper({
      name: 'QnA API',
      type: 'GET',
      url: url,
    })
      .then(response => {
        if (response && response.data) {
          let data = response.data as QNADataType;
          dispatch(updateQnaDataStatus(false));
          dispatch(setQNAData(data));
          if (data.data && data.data.length > 0) {
            dispatch(updateHasQnaDataAction(true));
          }
        }
      })
      .catch(() => {
        dispatch(setQNAData({} as QNADataType));
      });
  };
};

//Get Particular question detail in QNA
export function getQuesDetails({qid, hFilter = false}, cb) {
  const url =
    'https://ugc.goibibo.com/api/Questions/' + qid + '/getQuestionDetailV2?hFilter=' + hFilter;

  xhrHelper({
    name: 'Question Detail API',
    type: 'GET',
    url: url,
  })
    .then(response => {
      if (response && response.data) {
        let data = response.data as QuesDetailType;
        return cb(data);
      }
    })
    .catch(err => {
      console.log('Detail Qna API call failed');
      console.trace(err);
      return cb([]);
    });
}

// export function likeReview({hotelReviewId, isLiked = true}) {
//   const url = 'https://ugcpp.goibibo.com/api/Likes/likeReviews';
//   const data = {
//     likeDetails: [{
//       id: hotelReviewId,
//       isLiked,
//       deviceType: 'web'
//     }]
//   };
//   return axios.post(url, data, {'withCredentials': true});
// }
